const STORAGE_KEY = 'empty-invoice-prompt-shown';
const WINDOW_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

type ShownMap = Record<string, number>;

const readMap = (): ShownMap => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? (parsed as ShownMap) : {};
    } catch {
        return {};
    }
};

const writeMap = (map: ShownMap): void => {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
    } catch {
        // ignore — storage may be unavailable (private mode, etc)
    }
};

const pruneStale = (map: ShownMap, now: number): ShownMap => {
    const cutoff = now - WINDOW_MS;
    const result: ShownMap = {};
    for (const [id, ts] of Object.entries(map)) {
        if (typeof ts === 'number' && ts > cutoff) {
            result[id] = ts;
        }
    }
    return result;
};

export const wasEmptyInvoicePromptShownRecently = (invoiceId: number): boolean => {
    const now = Date.now();
    const map = readMap();
    const ts = map[String(invoiceId)];
    return typeof ts === 'number' && now - ts < WINDOW_MS;
};

export const markEmptyInvoicePromptShown = (invoiceId: number): void => {
    const now = Date.now();
    const map = pruneStale(readMap(), now);
    map[String(invoiceId)] = now;
    writeMap(map);
};
